import { makeContextModule } from '@cian/react-utils';
const { Context, useContext } = makeContextModule({
    contextName: 'MicrofrontendContext',
});
/**
 * Контекст, в который необходимо прокинуть текущий микрофронтенд
 * для работы @cian/mf-react
 */
export const MicrofrontendContext = Context;
/**
 * Хук для получения текущего микрофронтенда из контекста
 *
 * @return {*}  {IMicrofrontend}
 */
export const useMicrofrontend = useContext;
//# sourceMappingURL=Microfrontend.js.map